export enum TourId {
  OnboardingWelcome = `5f91b5c86a6b2c0009b9892f`,
  OnboardingHelpAfterExitOnce = `5f74e4acdd9bfe00075311d0`,
  InsightsNewMetrics = `5ea727a958c5b300049cf88a`,
  InsightsNewQueryBuilder = `5d8182c31ce3d3000418a7a8`,
  Retention = `5eb07cfa2e576200047f5eec`,
  Impact = `5e138855619c7e0004ea0cde`,
  LaunchAnalysis = `5e138855619c7e0004ea0cde`,
  Flows = `5eb5d96c17c5cf00047961aa`,
}

export enum TourState {
  Completed = `completed`,
  Exited = `exited`,
  Started = `started`,
  NotStarted = `not-started`,
}

export enum EventName {
  TourCompleted = `Chameleon Completed Tour`,
}

export function getTourState(tourId: TourId): TourState {
  const state = window.chmln?.data?.tours?.find((tour) => tour.get(`campaign.id`) === tourId)?.get(`state`);
  return state || TourState.NotStarted;
}

export function isChameleonReady() {
  return `chmln` in window;
}

export function showTour(tourId: TourId) {
  window.chmln?.show(tourId);
}
